<template>
  <div >
    <div class="tips" v-if="form_id == 0">重要提醒：所有信息一经提交无法修改，提交前请仔细核对信息！请勿随意申报</div>
    <van-form @submit="onSubmit">
      <van-field
        v-if="form_id != 0"
        v-model="form_id"
        :disabled="disabled"
        label="申请id"
        placeholder=""
      />
      <van-field
        v-model="form.name"
        :disabled="disabled"
        name="name"
        label="姓名"
        placeholder="需和银行账户的户名一致"
        :rules="[{ required: true, message: '请填写姓名' }]"
      />
      <van-field
        v-model="form.id_number"
        :disabled="disabled"
        name="id_number"
        label="身份证号"
        placeholder="身份证号"
        @blur="matchId"
        :rules="[{ required: true, message: '请填写正确身份证号',patternId }]"
      />
      <van-field
        v-model="form.telephone"
        :disabled="disabled"
        name="telephone"
        label="手机号"
        type="digit"
        placeholder="手机号"
        @blur="matchTel"
        :rules="[{ required: true, message: '请填写正确手机号',patternTel }]"
      />
      <van-field
        v-model="form.bank_name"
        :disabled="disabled"
        name="bank_name"
        label="银行开户行"
        placeholder="银行开户行"
        :rules="[{ required: true, message: '请填写银行开户行' }]"
      />
      <van-field
        v-model="form.bank_card_no"
        name="bank_card_no"
        :disabled="disabled"
        label="银行卡号"
        placeholder="银行卡号"
        :rules="[{ required: true, message: '请填写银行卡号' }]"
      />
      <van-field
        v-model="form.bank_card_telephone"
        name="bank_card_telephone"
        :disabled="disabled"
        label="银行账户预留手机号"
        placeholder="银行账户预留手机号"
        :rules="[{ required: true, message: '请填写银行账户预留手机号' }]"
      />
      <van-field v-model="form.photo_id_front" name="photo_id_front" label="身份证照片（正面）" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <div class="upload-bar" v-if="form.photo_id_front == ''">
            <van-image class="upload-icon" src="" @click="upload('photo_id_front')">
              <template v-slot:error>
                <van-loading v-if="uploading.photo_id_front" type="spinner" size="20" />
                <p v-else>点击上传</p>
              </template>
            </van-image>
            <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
          </div>
          <div class="upload-icon" v-else>
            <van-image class="upload-icon" :src="form.photo_id_front" @click="preview(form.photo_id_front)">
            </van-image>
            <div class="upload-delete" v-if="!disabled" @click="deleteImg('photo_id_front')">
              <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
            </div>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_id_reverse" name="photo_id_reverse" label="身份证照片（背面）" :disabled="disabled" >
        <template #input>
          <div class="upload-bar" v-if="form.photo_id_reverse == ''">
            <van-image class="upload-icon" src="" @click="upload('photo_id_reverse')">
              <template v-slot:error>
                <van-loading v-if="uploading.photo_id_reverse" type="spinner" size="20" />
                <p v-else>点击上传</p>
              </template>
            </van-image>
            <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
          </div>
          <div class="upload-icon" v-else>
            <van-image class="upload-icon" :src="form.photo_id_reverse" @click="preview(form.photo_id_reverse)">
            </van-image>
            <div class="upload-delete" v-if="!disabled" @click="deleteImg('photo_id_reverse')">
              <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
            </div>
          </div>
        </template>
      </van-field>
      <van-divider>报废车辆信息</van-divider>
      <van-field name="emission" v-model="form.emission" label="报废车辆排放" :disabled="disabled" :rules="[{ required: true, message: '请填选择' }]">
        <template #input>
          <van-radio-group :disabled="disabled" v-model="form.emission" direction="horizontal">
            <van-radio name="1">国四燃油车</van-radio>
            <van-radio name="2">国五燃油车</van-radio>
            <van-radio name="3">国六燃油车</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <van-field
        v-model="form.scrap_car_serial_no"
        :disabled="disabled"
        name="scrap_car_serial_no"
        label="报废车辆识别代号"
        placeholder="填写报废车辆识别代号"
        :rules="[{ required: true, message: '填写报废车辆识别代号' }]"
      />
      <van-field
        v-model="form.scrap_car_no"
        :disabled="disabled"
        name="scrap_car_no"
        label="报废车辆车牌号"
        placeholder="填写报废车辆车牌号"
        :rules="[{ required: true, message: '填写报废车辆车牌号' }]"
      />
      <van-field
        v-model="form.scrap_evidence_no"
        :disabled="disabled"
        name="scrap_evidence_no"
        label="报废车辆回收证明编号"
        placeholder="填写报废车辆回收证明编号"
        :rules="[{ required: true, message: '填写报废车辆回收证明编号' }]"
      />
      <van-field
        readonly
        :disabled="disabled"
        clickable
        name="scrap_car_back_date"
        :value="form.scrap_car_back_date"
        label="报废车辆交车日期"
        placeholder="报废车辆交车日期"
        @click="showPicker.scrap_car_back_date = true"
      />
      <van-popup v-model="showPicker.scrap_car_back_date" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          title="选择报废车辆交车日期"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onScrapBackDateConfirm"
          @cancel="showPicker.scrap_car_back_date = false"
        />
      </van-popup>
      <van-field
        v-model="form.scrap_car_back_location"
        is-link
        readonly
        :disabled="disabled"
        name="scrap_car_back_location"
        label="报废车辆回收地"
        placeholder="请选择地区"
        @click="locationSelectShow.scrap_car_back_location = true"
      />
      <van-popup v-model="locationSelectShow.scrap_car_back_location" round position="bottom">
        <van-cascader
          v-model="cascader.scrap_car_back_location"
          title="请选择地区"
          :options="locationOptions"
          @close="locationSelectShow.scrap_car_back_location = false"
          @finish="onScrapBackLocation"
        />
      </van-popup>

      <van-field
        readonly
        :disabled="disabled"
        clickable
        name="scrap_car_regist_date"
        :value="form.scrap_car_regist_date"
        label="报废车辆注册登记日期"
        placeholder="报废车辆注册登记日期"
        @click="showPicker.scrap_car_regist_date = true"
      />
      <van-popup v-model="showPicker.scrap_car_regist_date" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          title="选择报废车注册登记日期"
          type="date"
          :min-date="minDate2"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onScrapRegistDateConfirm"
          @cancel="showPicker.scrap_car_regist_date = false"
        />
      </van-popup>
      <van-field
        readonly
        :disabled="disabled"
        clickable
        name="scrap_car_logout_date"
        :value="form.scrap_car_logout_date"
        label="报废车辆注销日期"
        placeholder="报废车辆注销日期"
        @click="showPicker.scrap_car_logout_date = true"
      />
      <van-popup v-model="showPicker.scrap_car_logout_date" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          title="选择报废车注销车日期"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onScrapLogoutDateConfirm"
          @cancel="showPicker.scrap_car_logout_date = false"
        />
      </van-popup>
      <van-field
        v-model="form.scrap_car_regist_location"
        is-link
        readonly
        :disabled="disabled"
        name="scrap_car_regist_location"
        label="报废车辆登记地"
        placeholder="请选择地区"
        @click="locationSelectShow.scrap_car_regist_location = true"
      />
      <van-popup v-model="locationSelectShow.scrap_car_regist_location" round position="bottom">
        <van-picker
          title="请选择地区"
          show-toolbar
          :columns="locationOptions2"
          @confirm="onScrapRegistLocation"
        />
      </van-popup>
      <van-field v-model="form.photo_scrap_car_evidence" name="photo_scrap_car_evidence" label="报废机动车回收证明" :disabled="disabled" :rules="[{ required: true, message: '请上传图片' }]">
        <template #input>
          <div class="upload-bar" v-if="form.photo_scrap_car_evidence == ''">
            <van-image class="upload-icon" src="" @click="upload('photo_scrap_car_evidence')">
              <template v-slot:error>
                <van-loading v-if="uploading.photo_scrap_car_evidence" type="spinner" size="20" />
                <p v-else>点击上传</p>
              </template>
            </van-image>
            <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
          </div>
          <div class="upload-icon" v-else>
            <van-image class="upload-icon" :src="form.photo_scrap_car_evidence" @click="preview(form.photo_scrap_car_evidence)">
            </van-image>
            <div class="upload-delete" v-if="!disabled" @click="deleteImg('photo_scrap_car_evidence')">
              <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
            </div>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_scrap_car_logout_evidence" name="photo_scrap_car_logout_evidence" label="报废车辆注销证明" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <div class="upload-bar" v-if="form.photo_scrap_car_logout_evidence == ''">
            <van-image class="upload-icon" src="" @click="upload('photo_scrap_car_logout_evidence')">
              <template v-slot:error>
                <van-loading v-if="uploading.photo_scrap_car_logout_evidence" type="spinner" size="20" />
                <p v-else>点击上传</p>
              </template>
            </van-image>
            <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
          </div>
          <div class="upload-icon" v-else>
            <van-image class="upload-icon" :src="form.photo_scrap_car_logout_evidence" @click="preview(form.photo_scrap_car_logout_evidence)">
            </van-image>
            <div class="upload-delete" v-if="!disabled" @click="deleteImg('photo_scrap_car_logout_evidence')">
              <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
            </div>
          </div>
        </template>
      </van-field>
      <van-divider>新车信息</van-divider>
      <van-field name="new_car_type" v-model="form.new_car_type" label="新车类型" :disabled="disabled" :rules="[{ required: true, message: '请填选择' }]">
        <template #input>
          <van-radio-group :disabled="disabled" v-model="form.new_car_type" direction="horizontal">
            <van-radio name="1">新能源车</van-radio>
            <van-radio name="2">国六B以上燃油车</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.car_price"
        :disabled="disabled"
        name="car_price"
        label="新车购车价格/元(不含税)"
        type="number"
        placeholder="需与发票上购车金额一致"
        :rules="[{ required: true, message: '购车价不低于100000', validator: priceValidate }]"
      >
        <template slot="right-icon">
          (不含税)
        </template>
      </van-field>
      <van-field
        v-model="form.new_car_serial_no"
        :disabled="disabled"
        name="new_car_serial_no"
        label="新车车辆识别代号"
        placeholder="填写新车车辆识别代号"
        :rules="[{ required: true, message: '填写新车车辆识别代号' }]"
      />
      <van-field
        v-model="form.new_car_no"
        :disabled="disabled"
        name="new_car_no"
        label="新车车牌号"
        placeholder="填写新车车牌号"
        :rules="[{ required: true, message: '填写新车车牌号' }]"
      />
      <van-field
        v-model="form.new_car_invoice_no"
        :disabled="disabled"
        name="new_car_invoice_no"
        label="新车发票代码"
        placeholder="填写新车发票代码"
        :rules="[{ required: true, message: '填写新车发票代码' }]"
      />
      <van-field
        readonly
        :disabled="disabled"
        clickable
        name="new_car_invoice_date"
        :value="form.new_car_invoice_date"
        label="新车开票日期"
        placeholder="新车购车开票日期"
        @click="showPicker.new_car_invoice_date = true"
      />
      <van-popup v-model="showPicker.new_car_invoice_date" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          title="选择新车开票日期"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onInvoiceDateConfirm"
          @cancel="showPicker.new_car_invoice_date = false"
        />
      </van-popup>
      <van-field
        v-model="form.new_car_invoice_location"
        is-link
        readonly
        :disabled="disabled"
        name="new_car_invoice_location"
        label="新车发票开具地"
        placeholder="请选择地区"
        @click="locationSelectShow.new_car_invoice_location = true"
      />
      <van-popup v-model="locationSelectShow.new_car_invoice_location" round position="bottom">
        <!-- <van-picker
          title="请选择地区"
          show-toolbar
          :columns="locationOptions"
          @confirm="onInvoiceLocation"
        /> -->
        <van-cascader
          v-model="cascader.new_car_invoice_location"
          title="请选择地区"
          :options="locationOptions"
          @close="locationSelectShow.new_car_invoice_location = false"
          @finish="onInvoiceLocation"
        />
      </van-popup>
      <van-field
        readonly
        :disabled="disabled"
        clickable
        name="new_car_regist_date"
        :value="form.new_car_regist_date"
        label="新车注册登记日期"
        placeholder="新车注册登记日期"
        @click="showPicker.new_car_regist_date = true"
      />
      <van-popup v-model="showPicker.new_car_regist_date" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          title="选择新车注册登记日期"
          type="date"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @confirm="onNewRegistDateConfirm"
          @cancel="showPicker.new_car_regist_date = false"
        />
      </van-popup>
      <van-field
        v-model="form.new_car_model_no"
        :disabled="disabled"
        name="new_car_model_no"
        label="新车车辆型号"
        placeholder="填写新车车辆型号"
        :rules="[{ required: true, message: '填写新车车辆型号' }]"
      />
      <van-field
        v-model="form.new_car_regist_location"
        is-link
        readonly
        :disabled="disabled"
        name="new_car_regist_location"
        label="新车注册登记地"
        placeholder="请选择地区"
        @click="locationSelectShow.new_car_regist_location = true"
      />
      <van-popup v-model="locationSelectShow.new_car_regist_location" round position="bottom">
        <!-- <van-picker
          title="请选择地区"
          show-toolbar
          :columns="locationOptions"
          @confirm="onNewRegistLocation"
        /> -->
        <van-cascader
          v-model="cascader.new_car_regist_location"
          title="请选择地区"
          :options="locationOptions"
          @close="locationSelectShow.new_car_regist_location = false"
          @finish="onNewRegistLocation"
        />
      </van-popup>
      <van-field v-model="form.photo_new_car_invoice"  name="photo_new_car_invoice" label="新车购车发票照片" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <div class="upload-bar" v-if="form.photo_new_car_invoice == ''">
            <van-image class="upload-icon" src="" @click="upload('photo_new_car_invoice')">
              <template v-slot:error>
                <van-loading v-if="uploading.photo_new_car_invoice" type="spinner" size="20" />
                <p v-else>点击上传</p>
              </template>
            </van-image>
            <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
          </div>
          <div class="upload-icon" v-else>
            <van-image class="upload-icon" :src="form.photo_new_car_invoice" @click="preview(form.photo_new_car_invoice)">
            </van-image>
            <div class="upload-delete" v-if="!disabled" @click="deleteImg('photo_new_car_invoice')">
              <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
            </div>
          </div>
        </template>
      </van-field>
      <van-field v-model="form.photo_new_car_regist" name="photo_new_car_regist" label="新车机动车登记证书" :disabled="disabled" :rules="[{ required: true, message: '请填上传图片' }]">
        <template #input>
          <div class="upload-bar" v-if="form.photo_new_car_regist == ''">
            <van-image class="upload-icon" src="" @click="upload('photo_new_car_regist')">
              <template v-slot:error>
                <van-loading v-if="uploading.photo_new_car_regist" type="spinner" size="20" />
                <p v-else>点击上传</p>
              </template>
            </van-image>
            <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
          </div>
          <div class="upload-icon" v-else>
            <van-image class="upload-icon" :src="form.photo_new_car_regist" @click="preview(form.photo_new_car_regist)">
            </van-image>
            <div class="upload-delete" v-if="!disabled" @click="deleteImg('photo_new_car_regist')">
              <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
            </div>
          </div>
        </template>
      </van-field>
      <p style="color:red;line-height:2em;padding-top:1em">请仔细核对信息后提交！<br/>提交后如需修改请联系0575-85211754退回。</p>
    
      <div style="margin: 16px;padding-bottom: 2rem;" v-if="form_id == 0">
        <van-button round :disabled="disabled" block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <!-- <van-form v-if="form_id > 0" @submit="onSubmit2">
        <van-field v-model="form.photo_driving_license" name="photo_driving_license" label="车辆行驶证照片" :disabled="disabled2" :rules="[{ required: true, message: '请填上传图片' }]">
          <template #input>
            <div class="upload-bar" v-if="!form.photo_driving_license || form.photo_driving_license == ''">
              <van-image class="upload-icon" src="" @click="upload('photo_driving_license')">
                <template v-slot:error>
                  <van-loading v-if="uploading.photo_driving_license" type="spinner" size="20" />
                  <p v-else>点击上传</p>
                </template>
              </van-image>
              <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
            </div>
            <div class="upload-icon" v-else>
              <van-image class="upload-icon" :src="form.photo_driving_license" @click="preview(form.photo_driving_license)">
              </van-image>
              <div class="upload-delete" v-if="!disabled2" @click="deleteImg('photo_driving_license')">
                <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
              </div>
            </div>
          </template>
        </van-field>
        <van-field v-model="form.photo_purchase_tax" name="photo_purchase_tax" label="车辆购置税凭证照片" :disabled="disabled2" :rules="[{ required: true, message: '请填上传图片' }]">
          <template #input>
            <div class="upload-bar" v-if="!form.photo_purchase_tax || form.photo_purchase_tax == ''">
              <van-image class="upload-icon" src="" @click="upload('photo_purchase_tax')">
                <template v-slot:error>
                  <van-loading v-if="uploading.photo_purchase_tax" type="spinner" size="20" />
                  <p v-else>点击上传</p>
                </template>
              </van-image>
              <p class="upload-tips">ios客户端请选择“本地相册”上传图片</p>
            </div>
            <div class="upload-icon" v-else>
              <van-image class="upload-icon" :src="form.photo_purchase_tax" @click="preview(form.photo_purchase_tax)">
              </van-image>
              <div class="upload-delete" v-if="!disabled2" @click="deleteImg('photo_purchase_tax')">
                <van-icon name="cross" color="#ffffff" style="position: absolute;right: 0;" size="12px"/>
              </div>
            </div>
          </template>
        </van-field>
        <div style="margin: 16px;padding-bottom: 2rem;" v-if="form_id > 0">
          <van-button round :disabled="disabled2" block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form> -->
  </div>
</template>
<script>
import axios from 'axios'
import { mc,util } from '../../assets/common2.js'
import { ImagePreview } from 'vant'
export default {
  name: 'CarOldForNewForm',
  props: {
  },
  data () {
    return {
      patternId: /^[1-8][1-7]\d{4}(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/,
      patternTel: /^1[3-9]\d{9}$/,
      form:{
        telephone: '',
        name:'',
        id_number: '',
        emission: '',
        car_price: null,
        bank_name: '',
        bank_card_no: '',
        bank_card_telephone: '',
        scrap_date: null,
        scrap_car_serial_no: '',
        scrap_car_no: '',
        scrap_evidence_no: '',
        scrap_car_back_date: '',
        scrap_car_back_location: '',
        scrap_car_regist_date: null,
        scrap_car_logout_date: null,
        scrap_car_regist_location: '',
        photo_scrap_car_evidence: '',
        photo_scrap_car_logout_evidence: '',
        new_car_type: null,
        new_car_serial_no: '',
        new_car_no: '',
        new_car_invoice_no: '',
        new_car_invoice_date: null,
        new_car_invoice_location: '',
        new_car_regist_date: null,
        new_car_model_no: '',
        new_car_regist_location: '',
        photo_new_car_invoice: '',
        photo_new_car_regist: '',
        photo_id_front: '',
        photo_id_reverse: '',
        photo_invoice: '',
        photo_driving_license: '',
        photo_purchase_tax: '',
      },
      cascader: {
        scrap_car_back_location: ''
      },
      showPicker: {
        scrap_car_back_date: false,
        scrap_date: false,
        scrap_car_regist_date: false,
        scrap_car_logout_date: false,
        new_car_invoice_date: false,
        new_car_regist_date: false,
      },
      disabled: false,
      disabled2: false,
      currentDate: new Date(),
      minDate2: new Date(2000, 1, 1),
      // minDate: new Date(2024, 1, 1),
      // maxDate: new Date(2024, 2, 20),
      uploading: {
        photo_id_front: false,
        photo_id_reverse: false,
        photo_invoice: false,
        photo_purchase_tax: false,
        photo_driving_license: false,
        photo_scrap_car_evidence: false,
        photo_scrap_car_logout_evidence: false,
        photo_new_car_invoice: false,
        photo_new_car_regist: false,
      },
      photo_old_for_new: [],
      locationSelectShow: {
        scrap_car_back_location: false,
        scrap_car_regist_location: false,
        new_car_invoice_location: false,
        new_car_regist_location: false,
      },
      locationOptions2:  ['绍兴市','杭州市', '宁波市', '温州市', '湖州市', '嘉兴市', '金华市', '衢州市', '台州市','丽水市','舟山市'],
      locationOptions: [
        {
          text: '浙江省',
          value: '330',
          children: [
            {
              text: '绍兴市',
              value: '330600',
              children: [
                { text: '滨海新区',value: '330602'},
                { text: '越城区', value: '330602' },
                { text: '柯桥区', value: '330603' },
                { text: '上虞区', value: '330604' },
                { text: '诸暨市', value: '330681' },
                { text: '嵊州市', value: '330683' },
                { text: '新昌县', value: '330624' },
              ],
            },
            {
              text: '杭州市',
              value: '330100',
              children: [
                { text: '上城区', value: '330102' },
                { text: '下城区', value: '330103' },
                { text: '江干区', value: '330104' },
                { text: '拱墅区', value: '330105' },
                { text: '西湖区', value: '330106' },
                { text: '滨江区', value: '330108' },
                { text: '萧山区', value: '330109' },
                { text: '余杭区', value: '330110' },
                { text: '富阳区', value: '330111' },
                { text: '建德市', value: '330182' },
                { text: '临安市', value: '330185' },
                { text: '桐庐县', value: '330122' },
                { text: '淳安县', value: '330127' },
              ],
            },
            {
              text: '宁波市',
              value: '330200',
              children: [
                { text: '海曙区', value: '330203' },
                { text: '江东区', value: '330204' },
                { text: '江北区', value: '330205' },
                { text: '北仑区', value: '330206' },
                { text: '镇海区', value: '330211' },
                { text: '鄞州区', value: '330212' },
                { text: '余姚市', value: '330281' },
                { text: '慈溪市', value: '330282' },
                { text: '奉化市', value: '330283' },
                { text: '象山县', value: '330225' },
                { text: '宁海县', value: '330226' },
              ],
            },
            {
              text: '温州市',
              value: '330300',
              children: [
                { text: '鹿城区', value: '330302' },
                { text: '龙湾区', value: '330303' },
                { text: '瓯海区', value: '330304' },
                { text: '洞头区', value: '330305' },
                { text: '瑞安市', value: '330381' },
                { text: '乐清市', value: '330382' },
                { text: '永嘉县', value: '330324' },
                { text: '平阳县', value: '330326' },
                { text: '苍南县', value: '330327' },
                { text: '文成县', value: '330328' },
                { text: '泰顺县', value: '330329' },
              ],
            },
            {
              text: '嘉兴市',
              value: '330400',
              children: [
                { text: '南湖区', value: '330402' },
                { text: '秀洲区', value: '330411' },
                { text: '海宁市', value: '330481' },
                { text: '平湖市', value: '330482' },
                { text: '桐乡市', value: '330483' },
                { text: '嘉善县', value: '330421' },
                { text: '海盐县', value: '330424' },
              ],
            },
            {
              text: '湖州市',
              value: '330500',
              children: [
                { text: '吴兴区', value: '330502' },
                { text: '南浔区', value: '330503' },
                { text: '德清县', value: '330521' },
                { text: '长兴县', value: '330522' },
                { text: '安吉县', value: '330523' },
              ],
            },
            {
              text: '金华市',
              value: '330700',
              children: [
                { text: '婺城区', value: '330702' },
                { text: '金东区', value: '330703' },
                { text: '兰溪市', value: '330781' },
                { text: '义乌市', value: '330782' },
                { text: '东阳市', value: '330783' },
                { text: '永康市', value: '330784' },
                { text: '武义县', value: '330723' },
                { text: '浦江县', value: '330726' },
                { text: '磐安县', value: '330727' },
              ],
            },
            {
              text: '衢州市',
              value: '330800',
              children: [
                { text: '柯城区', value: '330802' },
                { text: '衢江区', value: '330803' },
                { text: '江山市', value: '330881' },
                { text: '常山县', value: '330822' },
                { text: '开化县', value: '330824' },
                { text: '龙游县', value: '330825' },
              ],
            },
            {
              text: '舟山市',
              value: '330900',
              children: [
                { text: '定海区', value: '330902' },
                { text: '普陀区', value: '330903' },
                { text: '岱山县', value: '330921' },
                { text: '嵊泗县', value: '330922' },
              ],
            },
            {
              text: '台州市',
              value: '331000',
              children: [
                { text: '椒江区', value: '331002' },
                { text: '黄岩区', value: '331003' },
                { text: '路桥区', value: '331004' },
                { text: '温岭市', value: '331081' },

                { text: '临海市', value: '331082' },
                { text: '玉环县', value: '331021' },
                { text: '三门县', value: '331022' },
                { text: '天台县', value: '331023' },
                { text: '仙居县', value: '331024' },
              ],
            },
            {
              text: '丽水市',
              value: '331100',
              children: [
                { text: '莲都区', value: '331102' },
                { text: '龙泉市', value: '331181' },
                { text: '青田县', value: '331121' },
                { text: '缙云县', value: '331122' },
                { text: '遂昌县', value: '331123' },
                { text: '松阳县', value: '331124' },
                { text: '云和县', value: '331125' },
                { text: '庆元县', value: '331126' },
                { text: '景宁畲族自治县', value: '331127' },
              ],
            },
          ]
        }
      ]
    }
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    minDate () {
      return this.$store.state.fid == 1 ? new Date(2024, 1, 1) : new Date(2024, 4, 10)
    },
    maxDate () {
      return this.$store.state.fid == 1 ? new Date(2024, 2, 20) : new Date(2024, 11, 31)
    }
  },
  created: function () {
    this.form_id = this.$route.params.form_id
    if (this.$route.params.form_id > 0) {
      this.disabled = true
      this.getDetail()
    }
    // this.active = this.$store.state.prevActive
  },
  mounted: function () {
    
  },
  methods: {
    matchTel () {
      if (!this.patternTel.test(this.form.telephone)) {
        this.$toast('请输入正确的手机号')
      }
    },
    matchId () {
      if (!this.patternId.test(this.form.id_number)) {
        this.$toast('请输入正确的身份证号')
      }
    },
    onScrapBackDateConfirm(date) {
      this.form.scrap_car_back_date = date.toLocaleString().split(' ')[0]
      this.showPicker.scrap_car_back_date = false
    },
    onScrapLogoutDateConfirm (date) {
      this.form.scrap_car_logout_date = date.toLocaleString().split(' ')[0]
      this.showPicker.scrap_car_logout_date = false
    },
    onScrapRegistDateConfirm (date) {
      this.form.scrap_car_regist_date = date.toLocaleString().split(' ')[0]
      this.showPicker.scrap_car_regist_date = false
    },
    onInvoiceDateConfirm(date) {
      this.form.new_car_invoice_date = date.toLocaleString().split(' ')[0]
      this.showPicker.new_car_invoice_date = false
    },
    onNewRegistDateConfirm(date) {
      this.form.new_car_regist_date = date.toLocaleString().split(' ')[0]
      this.showPicker.new_car_regist_date = false
    },
    onScrapBackLocation ({ selectedOptions }) {
      this.form.scrap_car_back_location = selectedOptions.map((option) => option.text).join('-')
      this.locationSelectShow.scrap_car_back_location = false
    },
    onScrapRegistLocation (location) {
      this.form.scrap_car_regist_location = location
      this.locationSelectShow.scrap_car_regist_location = false
    },
    onInvoiceLocation ({ selectedOptions }) {
      this.form.new_car_invoice_location = selectedOptions.map((option) => option.text).join('-')
      this.locationSelectShow.new_car_invoice_location = false
    },
    onNewRegistLocation({ selectedOptions }) {
      this.form.new_car_regist_location = selectedOptions.map((option) => option.text).join('-')
      this.locationSelectShow.new_car_regist_location = false
    },
    priceValidate (val) {
      return val >= 100000
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    upload (key) {
      this.uploading[key] = true
      let n = key == 'photo_old_for_new' ? 5 : 1
      mc.photoSelect(n,(data) => {
        if (data.status == 'complete') {
          let imgs = this.form[key] == '' ? [] : this.form[key].split(',')
          this.form[key] = imgs.concat(data.imgs.map(e => {
            return e.url.replace('http:','')
          })).join(',')
          // console.log(data.imgs);
          this.uploading[key] = false
        } else {
          this.uploading[key] = false
        }
      })
    },
    uploadImg () {

    },
    deleteImg (key) {
      this.form[key] = ''
    },
    deleteImgList (key,idx) {
      let list = this.form[key].split(',')
      this.form[key] = list.filter((e,i) => {
        return i != idx
      }).join(',')
      console.log(this.form[key]);
    },
    preview(img) {
      ImagePreview([img])
    },
    onSubmit(values) {
      values.type = parseInt(values.type)
      values.buy_date = this.currentDate
      util.Arequest((data) => {
        // values.token = data.token
        var formData = new FormData()
        formData.append('token',data.token)
        for (const key in values) {
          formData.append(key,values[key])
        } 
        axios.post(`/encrypt3/form/car/submit3?userid=${data.userid}&fid=${this.$store.state.fid}`,formData).then(res => {
            if (res.data.msg == 'ok') {
              this.disabled = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('提交成功')
            } else if (res.data.msg == 'date error') {
              this.$toast('旧车报废日期或新车开票日期不符合')
            } else if (res.data.msg == 'not admin') {
              this.disabled = true
              this.$toast('无权限')
            } else if (res.data.msg == 'exists') {
              // this.disabled = true
              this.$toast('已有提交记录\n无法再次提交')
            } else if (res.data.msg == 'no start') {
              // this.disabled = true
              this.$toast('申请还未开始')
            } else if (res.data.msg == 'end') {
              // this.disabled = true
              this.$toast('申请已经结束')
            } else {
              this.$toast('提交失败\n请重试')
            } 
          }).catch(() => {
            
            this.$toast('网络繁忙\n稍后请重试')
          })
      })
    },
    onSubmit2(values) {
      util.Arequest((data) => {
        var data2 = {
          form_id: this.form_id,
          photo_driving_license: values.photo_driving_license,
          photo_purchase_tax: values.photo_purchase_tax,
          token: data.token
        }
        axios.post(`/encrypt3/form/car/submit2?userid=${data.userid}&fid=${this.$store.state.fid}`,data2).then(res => {
            if (res.data.msg == 'ok') {
              this.disabled2 = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('提交成功')
            } else if (res.data.msg == 'not admin') {
              this.disabled = true
              this.$toast('无权限')
            } else if (res.data.msg == 'error form_id') {
              this.disabled = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('该申请不存在')
            } else if (res.data.msg == 'error merchant') {
              this.disabled = true
              this.$toast('申请不属于该经销商')
            } else if (res.data.msg == 'error status') {
              this.disabled = true
              this.$store.commit('setNeedRefresh',true)
              this.$toast('该申请已提交或已作废')
            } else if (res.data.msg == 'no start') {
              this.disabled = true
              this.$toast('申请还未开始')
            } else if (res.data.msg == 'end') {
              this.disabled = true
              this.$toast('申请已经结束')
            } else {
              this.$toast('提交失败\n请重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n请重试')
          })
      })
    },
    getDetail() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/detail?form_id=${this.form_id}&userid=${data.userid}&fid=${this.$store.state.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              res.data.form.type = ''+res.data.form.type
              this.form = res.data.form
              this.loading = false;
            } else if (res.data.msg == 'not admin') {
              this.$toast('无权限')
            } else if (res.data.msg == 'not exists') {
              this.$toast('没有该申请')
            } else if (res.data.msg == 'error merchant') {
              this.$toast('非法请求')
            } else {
              this.$toast('网络繁忙\n稍后重试')
            } 
          }).catch(() => {
            this.$toast('网络繁忙\n稍后重试')
          })
      })
    },
    
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */
.tips {
  font-size: 1rem;
  color: red;
  padding: 0 1rem;
  text-align: left;
  line-height: 2rem;
}
.upload-bar {
  display: flex;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  height: 4.5rem;
}
.upload-icon {
  position: relative;
  width: 4.5rem;
  height: 4.5rem;
}
.upload-delete {
  position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
}
.upload-tips {
  margin-left: 2rem;
  width: 6rem;
  font-size: 0.8rem;
  color: rgb(255, 76, 76);
}
.upload-list {
  display: flex;
  flex-wrap: wrap;
}
.upload-list .upload-item {
  margin-right: 0.2rem;
  margin-top: 0.2rem;
}
</style>
